import React from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "./routes";

import { AuthProvider } from "./contexts/AuthContext";
import ThemeProvider from "./theme/index";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ThemeProvider>
          <Router />
        </ThemeProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
